import { motion } from "framer-motion";
import { ScrollText, ShieldCheck, Cpu, Mail } from "lucide-react";
import { useApp } from "@/context/AppProviders";
import { SUPPORT_EMAIL } from "@/config";

const icons = [ScrollText, ShieldCheck, Cpu];

const Compliance = () => {
  const { t } = useApp();
  const cp = t.compliance;

  return (
    <section
      id="compliance"
      data-testid="compliance-section"
      className="py-24 sm:py-32 border-t border-border bg-card/30"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl"
        >
          <p className="font-mono text-sm uppercase tracking-widest text-blue-500">
            {cp.label}
          </p>
          <h2 className="font-heading mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
            {cp.title}
          </h2>
        </motion.div>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {cp.cards.map((card, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={card.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`compliance-card-${i}`}
                className="rounded-sm border border-border bg-card p-8"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-sm border border-blue-600/30 bg-blue-600/10 text-blue-500">
                  <Icon className="h-6 w-6" strokeWidth={2} />
                </div>
                <h3 className="font-heading mt-5 text-lg font-medium tracking-tight">
                  {card.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                  {card.desc}
                </p>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-8 flex flex-col items-start gap-3 rounded-sm border border-border bg-card p-6 sm:flex-row sm:items-center sm:justify-between"
        >
          <p className="text-sm text-muted-foreground">{cp.contactLabel}</p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            data-testid="compliance-contact"
            className="inline-flex h-10 items-center gap-2 rounded-sm bg-blue-600 px-5 text-sm font-medium text-white hover:bg-blue-500 transition-colors duration-200"
          >
            <Mail className="h-4 w-4" />
            {cp.contactBtn} · {SUPPORT_EMAIL}
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Compliance;
